import { render } from "./Panner.vue?vue&type=template&id=8de2f03a&ts=true"
import script from "./Panner.vue?vue&type=script&lang=ts"
export * from "./Panner.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__